import Vue from 'vue';
import VueRouter from 'vue-router';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [{

		path: '/',
		name: 'SignIn',
		component: () =>
			import( /* webpackChunkName: "about" */ '../views/SignIn.vue'),
		meta: {
			title: "",
			show: true
		},

	},
	{
		path: '/Home',
		name: 'Home',
		component: () =>
			import('../views/Home.vue'),
		meta: {
			title: "",
			show: true
		},
		children: [{
			path: '/accountManagement',
			name: 'accountManagement',
			component: () =>
				import('../views/accountManagement/index.vue'),
		}, {
			path: '/TeakManagement',
			name: 'TeakManagement',
			component: () =>
				import('../views/TeakManagement.vue'),
		}, {
			path: '/ChanpinManagement',
			name: 'ChanpinManagement',
			component: () =>
				import('../views/ChanpinManagement.vue'),
		}, {
			path: '/seezhengshu',
			name: 'seezhengshu',
			component: () =>
				import('../views/seezhengshu.vue'),
		}, {
			path: '/testManagement',
			name: 'testManagement',
			component: () =>
				import('../views/testManagement/testIndex.vue'),
		}, {
			path: '/systemConfig',
			name: 'systemConfig',
			component: () =>
				import('../views/systemConfig/index'),
		}, ]
	},
	{
		path: '*',
		name: 'notfount',
		component: () => import('../views/404.vue'),
	}

];

const router = new VueRouter({
	routes,
});

export default router;
